<template>
    <div class="index">
        <!-- 导航栏 -->
        <div class="topNav">
            <div class="nav-box">
                <img class="nav-image" src="../../assets/index/logo2.png">
                <span class="nav-title">山东省泰山教育创新研究院技能等级考试系统</span>
            </div>
        </div>

        <div class="text-box">
            <div class="text-view">
                <p class="text-title">
                    {{ questionData.content }}
                    <span v-show="questionData.type == 1">(单选题)</span>
                    <span v-show="questionData.type == 3">(多选题)</span>
                    <span v-show="questionData.type == 2">(判断题)</span>
                    
                </p>
                <div class="text-image-view" v-show="questionData.imgUrl">
                    <img class="text-image-item" :src="`http://resource.home121.net/` + questionData.imgUrl">
                </div>

                <div class="topic-view">
                    <div class="topic-view-item" v-for="(item, index) in options" :key="index">
                        <div class="topic-box">
                            <!-- 选择按钮 -->
                            <div 
                                :class="item.active == false ? 'topic-choose' : 'topic-choose-active'"
                                @click="chooseOption(item, index)"
                                ></div>
                            <!-- <div class="topic-choose-active"></div> -->
                            <span class="topic-text">{{ item.optionNo }}</span>
                            <span v-show="questionData.type !== 2" class="topic-text" style="margin-left: 10px;">{{ item.content }}</span>
                        </div>
                        <div class="topic-image-view" v-show="item.imgUrl">
                            <img class="topic-image-item" :src="`http://resource.home121.net/` + item.imgUrl">
                        </div>
                    </div>
                </div>

                <div class="buttons-view">
                    <div class="top-button">
                        <div 
                            :class="questionData.preQuestionId == null ? 'button-item button-none' : 'button-item'"
                            @click="preTitle"
                            >上一题</div>
                        <div 
                            :class="questionData.nextQuestionId == null ? 'button-item button-none' : 'button-item'"
                            @click="nextTitle"
                            >下一题</div>
                    </div>
                    <div v-show="questionData.nextQuestionId == null" class="bottom-button" @click="submit">提交</div>
                </div>
            </div>

            <div class="index-view">
                <div class="choose-view">
                    <div 
                        class="choose-item" 
                        v-for="(item, index) in questionData.barList" 
                        :key="index"
                        @click="toQuestion(item)"
                        >
                        <div v-if="item.currentQuestion == true" class="choose-now">{{ item.sort }}</div>
                        <div v-else>
                            <div v-show="item.whetherChecked == false" class="choose-none">{{ item.sort }}</div>
                            <div v-show="item.whetherChecked == true" class="choose-active">{{ item.sort }}</div>
                        </div>
                        <!-- <div v-show="item.whetherChecked == false" class="choose-none">{{ item.sort }}</div>
                        <div v-show="item.whetherChecked == true" class="choose-active">{{ item.sort }}</div>
                        <div v-show="item.currentQuestion == true" class="choose-now">{{ item.sort }}</div> -->
                    </div>
                </div>

                <div class="show-view">
                    <div class="show-item">
                        <div class="show-item-circle1"></div>
                        <div class="show-item-text">未做</div>
                    </div>
                    <div class="show-item">
                        <div class="show-item-circle2"></div>
                        <div class="show-item-text">已做</div>
                    </div>
                    <div class="show-item">
                        <div class="show-item-circle3"></div>
                        <div class="show-item-text">当前题目</div>
                    </div>

                </div>

            </div>

        </div>
        
        <!-- 弹窗 -->
        <div class="cover-box" v-show="coverShow">
            <div class="cover-item">
                <div class="cover-item-top">
                    <p>{{ txt }}</p>
                    <p>是否确认提交考试</p>
                </div>
                <div class="cover-item-bottom">
                    <div class="bottom-view bottom-left" @click="back">返回答题</div>
                    <div class="bottom-view" @click="toResult">确认提交</div>
                </div>
            </div>

        </div>

        

    </div>
</template>

<script>
    export default {
        name: 'exam',
        data() {
            return {
               coverShow: false,
               questionId: '',
               questionData: '',
               options: [],
               type: '', //1单选 2判断 3多选
               answer: '', //答案
               txt: ''
            }
        },
        created() {
            this.getQuestion()
        },
        methods: {
            getQuestion() {
                this.http.post('/exam/getQuestion', {
                    userId: this.$store.state.login.userId,
                    recordId: this.$store.state.login.recordId,
                    questionId: this.questionId
                }).then(res=> {
                    this.questionData = res.data.result
                    this.options = res.data.result.options
                    this.questionId = res.data.result.questionId
                    this.type = res.data.result.type
                    this.options.forEach(item => {
                        if(this.questionData.checkedValue == item.optionNo) {
                            item.active = true
                        } else {
                            item.active = false
                        }
                    })   
                }) 
            },
            chooseOption(data, index) {
                if(this.type == 1 || this.type == 2) {
                    // 单选、判断
                    this.options.forEach(item => {
                        item.active = false
                    })
                    this.options[index].active = true
                    this.answer = data.optionNo
                    this.$forceUpdate()
                } else {
                    if(data.active == true) {
                        this.options[index].active = false
                    } else {
                        this.options[index].active = true
                    }
                    
                    // 处理答案
                    let list = []
                    let i = 0
                    this.options.forEach(item => {
                        if(item.active == true) {
                            list[i++] = item.optionNo
                        }
                    })
                    this.answer = list.toString()
                    this.answer = this.answer.replace(/,/g, "")
                    this.$forceUpdate()
                }
                this.submitQuestion()
            },
            preTitle() {
                if(this.questionData.preQuestionId == null) {
                    return
                } else {
                    this.questionId = this.questionData.preQuestionId
                    this.getQuestion()
                }
                
            },
            nextTitle() {
                if(this.questionData.nextQuestionId == null) {
                    return
                } else {
                    this.questionId = this.questionData.nextQuestionId
                    this.getQuestion()
                }
                
            },
            toQuestion(data) {
                this.questionId = data.questionId
                this.getQuestion()
            },
            submit() {
                console.log(this.questionData.barList)
                this.txt = '已完成全部题目'
                this.questionData.barList.forEach(item => {
                    if(item.whetherChecked == false) {
                        this.txt = '存在未作答题目'
                    }
                })
                this.coverShow = true
            },
            back() {
                this.coverShow = false
            },
            toResult() {
                this.$router.replace({ name: 'result'})
            },
            submitQuestion() {
                this.http.post('/exam/submitQuestion', {
                    userId: this.$store.state.login.userId,
                    recordId: this.$store.state.login.recordId,
                    questionId: this.questionId,
                    result: this.answer
                }).then(res=> {
                    console.log(res)  
                    this.getQuestion()
                }) 
            }
        }
    }
</script>

<style lang="less" scoped>
    .index {
        width: 100%;
        min-height: 100vh;
        padding-bottom: 100px;
        box-sizing: border-box;
        background: #EEEEEE;
        .topNav {
            width: 100%;
            height: 100px;
            background-color: #368FCE;
            .nav-box {
                width: 100%;
                padding: 20px 140px;
                box-sizing: border-box;
                display: flex;
                .nav-image {
                    width: 35px;
                    height: 35px;
                    margin-top: 8px;
                }
                .nav-title {
                    margin-left: 11px;
                    font-size: 36px;
                    font-weight: 500;
                    color: #ffffff;
                }
                
            }
        
        }
        .text-box {
            width: 1595px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            padding-top: 50px;
            box-sizing: border-box;
            .text-view {
                width: 1190px;
                background: #FFFFFF;
                border-radius: 15px;
                padding: 50px 55px 134px 55px;
                box-sizing: border-box;
                .text-title {
                    font-size: 25px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 30px;
                }
                .text-image-view {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    margin-top: 5px;  
                    .text-image-item {
                        width: 200px;
                        height: auto;
                        border-radius: 8px;
                        margin-right: 10px;
                    }
                }
                .topic-view {
                    width: 100%;
                    margin-top: 5px;
                    .topic-view-item {
                        margin-top: 15px;
                        .topic-box {
                            display: flex;
                            .topic-choose {
                                width: 25px;
                                height: 25px;
                                background: #EEEEEE;
                                border-radius: 50%;
                                cursor: pointer;
                            }
                            .topic-choose-active {
                                width: 25px;
                                height: 25px;
                                background: #368FCE;
                                border-radius: 50%;
                                cursor: pointer;
                            }
                            .topic-text {
                                font-size: 25px;
                                font-weight: 400;
                                color: #333333;
                                line-height: 30px;
                                margin-left: 20px;
                            }
                        }
                        .topic-image-view {
                            display: flex;
                            margin-left: 45px;
                            margin-top: 10px;
                            .topic-image-item {
                                width: 200px;
                                height: auto;
                                border-radius: 8px;
                                margin-right: 10px;
                            }
                        }
                    }

                }
                .buttons-view {
                    width: 100%;
                    margin-top: 80px;
                    .top-button {
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        .button-item {
                            width: 151px;
                            height: 60px;
                            border-radius: 47px;
                            border: 1px solid #368FCE;
                            border-radius: 60px;
                            text-align: center;
                            line-height: 60px;
                            color: #368FCE;
                            font-size: 20px;
                            font-weight: 400;
                            margin-right: 88px;
                            cursor: pointer;
                        }
                        .button-none {
                            border: 1px solid #D8D8D8;
                            color: #D8D8D8;
                        }
                    }
                    .bottom-button {
                        margin: 0 auto;
                        margin-left: 300px;
                        margin-top: 40px;
                        width: 390px;
                        height: 60px;
                        background: #368FCE;
                        border-radius: 47px;
                        border: 1px solid #368FCE;
                        font-size: 20px;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 60px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }
            .index-view {
                width: 370px;
                height: 480px;
                background: #FFFFFF;
                border-radius: 15px;
                padding: 30px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                .choose-view {
                    width: 100%;
                    height: 370px;
                    border-bottom: 1px solid #F0F0F0;
                    overflow: auto;
                    display: flex; 
                    flex-flow: wrap;
                    .choose-item {
                        margin-right: 8px;
                        margin-bottom: 10px;
                        font-size: 20px;
                        font-weight: 400;
                        line-height: 46px;
                        text-align: center;
                        cursor: pointer;
                        .choose-none {
                            border: 2px solid #828282;
                            color: #828282;
                            border-radius: 50%;
                            width: 46px;
                            height: 46px;
                        }
                        .choose-active {
                            border: 2px solid #368FCE;
                            color: #368FCE;
                            border-radius: 50%;
                            width: 46px;
                            height: 46px;
                        }
                        .choose-now {
                            background: #368FCE;
                            border: 2px solid #368FCE;
                            color: #fff;
                            border-radius: 50%;
                            width: 46px;
                            height: 46px;
                        }
                    }
                }
                .show-view {
                    width: 100%;
                    height: 32px;
                    margin-top: 14px;
                    display: flex;
                    .show-item {
                        display: flex;
                        margin-right: 20px;
                        .show-item-circle1 {
                            width: 26px;
                            height: 26px;
                            border-radius: 50%;
                            border: 2px solid #828282;
                        }
                        .show-item-circle2 {
                            width: 26px;
                            height: 26px;
                            border-radius: 50%;
                            border: 2px solid #368FCE;
                        }
                        .show-item-circle3 {
                            width: 26px;
                            height: 26px;
                            border-radius: 50%;
                            background-color: #368FCE;
                            border: 2px solid #368FCE;
                        }
                        .show-item-text {
                            font-size: 18px;
                            font-weight: 400;
                            color: #828282;
                            margin-left: 5px;
                            line-height: 32px;
                        }
                    }
                }

            }
        }
        .cover-box {
            width: 100%;
            height: 100%;
            position: fixed;
            top: 0;
            left: 0;
            background-color: #0000007d;
            .cover-item {
                width: 789px;
                height: 410px;
                background: #FFFFFF;
                border-radius: 15px;
                margin: 0 auto;
                margin-top: 250px;
                .cover-item-top {
                    width: 100%;
                    height: 261px;
                    text-align: center;
                    padding: 75px 0 60px 0;
                    box-sizing: border-box;
                    font-size: 36px;
                    font-weight: 500;
                    color: #333333;
                    line-height: 63px;
                    border-bottom: 1px solid #D8D8D8;
                }
                .cover-item-bottom {
                    width: 100%;
                    height: 148px;
                    display: flex;
                    .bottom-view {
                        width: 50%;
                        height: 100%;
                        text-align: center;
                        line-height: 148px;
                        font-size: 36px;
                        font-weight: 500;
                        color: #333333;
                        cursor: pointer;
                    }
                    .bottom-left {
                        border-right: 1px solid #D8D8D8;
                    }
                }
            }
        }
       
    }
</style>